// Dependencies
import React, { useEffect, useRef } from "react";

// Components
import Heading from "components/typographies/Heading/Heading.component";

import useInventoryTitle from "hooks/inventory/useInventoryTitle.hook";

// Styles
import { useStyles } from "./InventoryTitle.styles";

const InventoryTitle = ({
  count = 2,
  radius,
  handleClick,
  userLocation,
  noLocation,
  setAnchorEl,
}) => {
  const classes = useStyles();

  const titleString = useInventoryTitle({ count, noLocation });
  const locationRef = useRef(null);

  useEffect(() => {
    setAnchorEl(locationRef.current);
  }, []);

  return (
    <div data-cy="inventory-title" className={classes.inventoryTitle}>
      <Heading
        className={classes.titleText}
        variant="h5"
        component="h1"
        key="inventory-title"
      >
        {titleString}
        <span
          ref={locationRef}
          onClick={handleClick}
          onKeyDown={handleClick}
          className={classes.locationButton}
          role="button"
          tabIndex={0}
        >
          {userLocation.city
            ? `${userLocation.city}, ${userLocation.province}`
            : "Select a location"}
          {!!radius && ` + ${radius}km`}
        </span>
      </Heading>
    </div>
  );
};

InventoryTitle.propTypes = {};

export default InventoryTitle;
